import React from 'react';
import {
  Button,
  Flex,
  Box,
  CModal,
  CModalBody,
  ModalCloseButton,
  ModalContent,
  CModalFooter,
  CModalHeader,
  ModalOverlay,
  ModalSize,
} from '@televet/kibble-ui';

interface IModal {
  isOpen: boolean;
  onClose: () => void;
  header?: string;
  children?: React.ReactNode;
  buttons: React.ReactNode;
  size?: ModalSize;
  hasCancel?: boolean;
  hasClose?: boolean;
  closeOnOverlayClick?: boolean;
  closeOnEsc?: boolean;
}

const Modal = ({
  isOpen,
  onClose,
  header,
  children,
  buttons,
  size = 'md',
  hasCancel = true,
  hasClose = true,
  closeOnOverlayClick = true,
  closeOnEsc = true,
}: IModal): JSX.Element => {
  return (
    <CModal
      size={size}
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={closeOnOverlayClick}
      closeOnEsc={closeOnEsc}
    >
      <ModalOverlay />
      <ModalContent>
        <CModalHeader fontSize="3xl" pb="1">
          {header}
        </CModalHeader>
        {hasClose && <ModalCloseButton />}
        <CModalBody>{children}</CModalBody>
        <CModalFooter justifyContent="space-between">
          {hasCancel ? (
            <Button variant="tertiary" onClick={onClose}>
              Cancel
            </Button>
          ) : (
            <Box />
          )}
          <Flex gap={3}>{buttons}</Flex>
        </CModalFooter>
      </ModalContent>
    </CModal>
  );
};

export default Modal;
